/**
 * Soft I1a: Ctrl/Cmd+Z = one undo of the entered hand input — only when focus
 * is NOT in a text field. In a text field (takeaway 「한 줄」, custom size,
 * blinds…) the browser's native text undo runs and no hand action is removed.
 * No toast, no banner, no confirm.
 */
import { getState, undoLast } from '../state'

const NON_TEXT_INPUTS = new Set(['button', 'checkbox', 'radio', 'submit', 'reset', 'range', 'color', 'file', 'image'])
const UNDO_STEPS = new Set(['setup', 'position', 'cards', 'actions', 'board'])

export function isTextEditTarget(target: unknown): boolean {
  const n = target as (HTMLElement & { isContentEditable?: boolean }) | null
  if (!n || typeof n !== 'object' || typeof n.tagName !== 'string') return false
  const tag = n.tagName.toUpperCase()
  if (tag === 'TEXTAREA' || tag === 'SELECT') return true
  if (tag === 'INPUT') {
    const type = (n.getAttribute?.('type') ?? 'text').toLowerCase()
    return !NON_TEXT_INPUTS.has(type)
  }
  if (n.isContentEditable === true) return true
  const ce = n.getAttribute?.('contenteditable')
  return ce === '' || ce === 'true' || ce === 'plaintext-only'
}

export function handleUndoKey(e: KeyboardEvent): boolean {
  if (e.defaultPrevented || e.isComposing) return false
  if (!(e.ctrlKey || e.metaKey) || e.altKey || e.shiftKey) return false
  if ((e.key ?? '').toLowerCase() !== 'z' && e.code !== 'KeyZ') return false
  if (isTextEditTarget(e.target)) return false
  if (typeof document !== 'undefined' && isTextEditTarget(document.activeElement)) return false
  const { view, step, softGate } = getState()
  if (view !== 'app' || softGate || !UNDO_STEPS.has(step)) return false
  if (!undoLast()) return false
  e.preventDefault()
  return true
}
